import { Injectable } from '@angular/core';
import { RestService } from '../shared/services/rest-service';
import { Observable } from 'rxjs';
import { ICreateNewsletterRequest } from './interfaces/i-create-newsletter-request';
import { INewsletterCategoryGroup } from './interfaces/i-newsletter-category-group';
import { ICreateNewsletterResponse } from './interfaces/i-create-newsletter-response';
import { INewsletterCategory } from './interfaces/i-newsletter-category';
import { IUpdateNewsletterRequest } from './interfaces/i-update-newsletter-request';
import { DeleteNewsletterRequest } from './interfaces/delete-newsletter-request';
import { INewsletterResponse } from './interfaces/i-newsletter-response';

@Injectable({
  providedIn: 'root',
})
export class NewsletterManagementService {
  static readonly ENTITY_IDENTIFIER: string = 'newsletters';
  private readonly BASE_NEWSLETTER_ROUTE = `api/${NewsletterManagementService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_NEWSLETTER_ROUTE, ...args);

  constructor(private restService: RestService) {}
  getAllNewsletters$(): Observable<INewsletterCategoryGroup[]> {
    return this.restService.get$<INewsletterCategoryGroup[]>(
      this.BUILD_HTTP_ROUTE()
    );
  }
  getNewsletterById$(id: number): Observable<INewsletterResponse> {
    return this.restService.get$<INewsletterResponse>(
      `${this.BUILD_HTTP_ROUTE()}${id}`
    );
  }
  createNewsletter$(
    request: ICreateNewsletterRequest
  ): Observable<ICreateNewsletterResponse> {
    return this.restService.post$(this.BUILD_HTTP_ROUTE(), request);
  }
  editNewsletter$(request: IUpdateNewsletterRequest): Observable<boolean> {
    return this.restService.put$(this.BUILD_HTTP_ROUTE(), request);
  }
  deleteNewsletter$(request: DeleteNewsletterRequest): Observable<boolean> {
    return this.restService.remove$(
      `${this.BUILD_HTTP_ROUTE()}${request.id}?regions=${
        request.regions
      }&includeIntranetTemplates=${request.includeIntranetTemplates}`
    );
  }
}
